import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/src/app/login/login.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/src/app/report/components/page/components/content/content.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/src/app/report/components/page/components/context-panel/context-panel.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/app/src/app/report/components/page/components/header/header.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/src/app/report/components/page/page.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FilePicker"] */ "/vercel/path0/app/src/components/sidebar/components/file-picker/file-picker.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/src/components/sidebar/components/global-search/global-search.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavItem"] */ "/vercel/path0/app/src/components/sidebar/components/navigation/components/navitem/navitem.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/vercel/path0/app/src/components/sidebar/components/navigation/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpaceSelector"] */ "/vercel/path0/app/src/components/sidebar/components/space-selector/space-selector.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserMenu"] */ "/vercel/path0/app/src/components/sidebar/components/user-menu/user-menu.component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/src/components/sidebar/sidebar.module.css");
